import React, { useState } from "react";
import {
	Dialog,
	DialogTitle,
	DialogContent,
	DialogActions,
	Button,
	TextField,
	FormControlLabel,
	Switch,
	makeStyles,
	CircularProgress,
} from "@material-ui/core";
import { toast } from "react-toastify";

import api from "../../services/api";
import toastError from "../../errors/toastError";

const useStyles = makeStyles((theme) => ({
	row: {
		display: "flex",
		gap: 8,
		marginTop: 8,
	},
	full: {
		width: "100%",
	},
}));

const pad = (n) => String(n).padStart(2, "0");
const toLocalInputValue = (date) => {
	const y = date.getFullYear();
	const m = pad(date.getMonth() + 1);
	const d = pad(date.getDate());
	const hh = pad(date.getHours());
	const mm = pad(date.getMinutes());
	return `${y}-${m}-${d}T${hh}:${mm}`;
};

const ScheduleMessageModal = ({
	open,
	onClose,
	ticketId,
	initialBody = "",
	scheduledMessage = null,
	onSaved,
}) => {
	const classes = useStyles();
	const isEdit = !!scheduledMessage;

	const defaultDate = new Date(Date.now() + 60 * 60 * 1000); // +1h
	const [body, setBody] = useState(
		isEdit ? scheduledMessage.body : initialBody
	);
	const [scheduledFor, setScheduledFor] = useState(
		isEdit
			? toLocalInputValue(new Date(scheduledMessage.scheduledFor))
			: toLocalInputValue(defaultDate)
	);
	const [cancelOnReply, setCancelOnReply] = useState(
		isEdit ? !!scheduledMessage.cancelOnReply : true
	);
	const [saving, setSaving] = useState(false);

	const handleSave = async () => {
		if (!body || !body.trim()) {
			toast.warn("Mensagem não pode estar vazia");
			return;
		}
		const when = new Date(scheduledFor);
		if (Number.isNaN(when.getTime())) {
			toast.warn("Data inválida");
			return;
		}
		if (when.getTime() <= Date.now()) {
			toast.warn("A data deve ser no futuro");
			return;
		}

		setSaving(true);
		try {
			if (isEdit) {
				const { data } = await api.put(
					`/scheduled-messages/${scheduledMessage.id}`,
					{
						body,
						scheduledFor: when.toISOString(),
						cancelOnReply,
					}
				);
				toast.success("Agendamento atualizado");
				onSaved && onSaved(data);
			} else {
				const { data } = await api.post("/scheduled-messages", {
					ticketId,
					body,
					scheduledFor: when.toISOString(),
					cancelOnReply,
				});
				toast.success("Mensagem agendada");
				onSaved && onSaved(data);
			}
			onClose();
		} catch (err) {
			toastError(err);
		} finally {
			setSaving(false);
		}
	};

	return (
		<Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
			<DialogTitle>
				{isEdit ? "Editar agendamento" : "Agendar mensagem"}
			</DialogTitle>
			<DialogContent>
				<TextField
					className={classes.full}
					label="Mensagem"
					multiline
					minRows={3}
					maxRows={8}
					value={body}
					onChange={(e) => setBody(e.target.value)}
					variant="outlined"
				/>
				<div className={classes.row}>
					<TextField
						className={classes.full}
						label="Data e hora"
						type="datetime-local"
						value={scheduledFor}
						onChange={(e) => setScheduledFor(e.target.value)}
						InputLabelProps={{ shrink: true }}
						variant="outlined"
					/>
				</div>
				<div className={classes.row}>
					<FormControlLabel
						control={
							<Switch
								checked={cancelOnReply}
								onChange={(e) =>
									setCancelOnReply(e.target.checked)
								}
								color="primary"
							/>
						}
						label="Cancelar automaticamente se o cliente responder"
					/>
				</div>
			</DialogContent>
			<DialogActions>
				<Button onClick={onClose} disabled={saving}>
					Cancelar
				</Button>
				<Button
					onClick={handleSave}
					color="primary"
					variant="contained"
					disabled={saving}
					startIcon={
						saving ? (
							<CircularProgress size={16} color="inherit" />
						) : null
					}
				>
					{isEdit ? "Salvar" : "Agendar"}
				</Button>
			</DialogActions>
		</Dialog>
	);
};

export default ScheduleMessageModal;
